export * from './src/quill.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-quill/index.js
// module id = 559
// module chunks = 0